<template>
    <transition name="slide-fade-enter-active slide-fade-enter" >
        <div>
            <div class="uk-padding">
                <div class="uk-container uk-container-small">
                    <h1 class="uk-heading-line uk-text-center">Management Team</h1>
                    <h3 class="uk-heading-bullet h2Style">Ronnie Dunn </h3>
                    <div class="uk-panel">
                        <img class="uk-align-center uk-align-right@m uk-margin-remove-adjacent uk-border-rounded"

                             src="../assets/Ronnie_Professional.jpg" width="325" height="100" alt="Example image">
<!--                        <p class="uk-text-lead">
                            Ronnie Dunn is the founder of FINCOR. He is a
                            Certified Public Accountant with over 20 years post qualification
                            experience.
                          <br><br>
                            He is also an MBA graduate with vast experience working
                            for the public and private sectors.
                        </p>-->
                        <p>
                          Ronnie Dunn is the Managing Director of FINCOR. He’s a CPA with over 20 years post-qualification
                          accounting experience, the holder of an MBA, a Certificate in Executive Healthcare Leadership from Cornell
                          University, a Notary Public in the Cayman Islands, and a current law student at the University of
                          Liverpool.
                        </p>

                        <p>
                          Ronnie previously worked for the Cayman Islands Government for over 14 years in the positions of Chief
                          Financial Officer, Director of Budget and Management, acted as Accountant General, and was most
                          recently the Deputy Chief Executive Officer for the Health Services Authority. He has also managed a
                          local manufacturing and construction company and chaired the Government’s Central Tenders
                          Committee (now Public Procurement Committee).
                        </p>
                        <p>
                          Ronnie specializes in public sector financial management and governance. He has over 10 years Board
                          experience with the National Roads Authority, the Civil Aviation Authority, the Utility Regulation and
                          Competition Office, and the Board of Governors for the University College of the Cayman Islands.
                        </p>
                      <p>
                        He’s passionate about working with management and Boards to build successful organizations and
                        improve shareholder value. He’s also an advocate for good governance and advises agencies on
                        compliance with the Public Authorities Act, the Procurement Act, and the Public Management and
                        Finance Act.
                      </p>
                    </div>
                </div>
            </div>
            <div class="uk-padding uk-background-muted">
                <div class="uk-container uk-container-small">
                    <h3 class="uk-heading-bullet h2Style">Lidka Scott</h3>
                    <div class="uk-panel">
                        <img class="uk-align-center uk-align-left@m uk-margin-remove-adjacent uk-border-rounded"
                             src="../assets/lidka1.jpg" width="325" height="150" alt="Example image">
                        <p>
                            Lidka Scott is the Senior Partner of FINCOR.  She is an Economist with over 10
                            years of experience in the areas of commercial and regulatory
                            banking, international finance, and fiscal policy, both locally and
                            abroad.
                        </p>
                        <p>
                            Upon completion of her Master’s Degree in Economics from the
                            University of Illinois, Scott worked for an international bank in New
                            York City where she reported directly to the Vice President of Finance
                            and supervised the team responsible for reconciling the North
                            American accounts.
                        </p>
                        <p>
                            Her public sector experience includes monitoring and reporting on the
                            local financial and immigration sectors as a Research Economist in the
                            Economics & Statistics Office, as well as assisting in the compilation of
                            the Government’s Annual Budget and various strategic policy
                            documents, during her role as Deputy Director of Budget &
                            Management.
                        </p>

                        <p>
                            Scott is responsible for quality assurance and strategic
                            services at FINCOR. Recently, her focus has been geared towards
                            assisting in the preparation of Strategic Outline Cases and Outline
                            Business Cases, drafting Job descriptions, policies and procedures
                            manuals, and providing strategic reengineering solutions for various
                            Ministries and Statutory Authorities in the Cayman Islands.
                        </p>

                    </div>
                </div>
            </div>
            <div class="uk-padding">
                <div class="uk-container uk-container-small">
                    <h3 class="uk-heading-bullet h2Style">Numan Sabir </h3>
                    <div class="uk-panel">
                        <img class="uk-align-center uk-align-right@m uk-margin-remove-adjacent uk-border-rounded"
                             src="../assets/numan.jpg" width="325" height="150" alt="Example image">
                        <p>
                            Numan Sabir is a Senior Accountant and Auditor at FINCOR. He
                            has more than 10 years of experience in Accounts, Finance and
                            Audit, and has in-depth professional work
                            experience managing the full finance functions for multi-
                            million dollar organizations in various sectors. Sabir is a member of the Association of Chartered
                            Certified Accountants (UK), and holds a Master of Commerce degree.
                        </p>
                        <p>
                            Sabir’s technical expertise includes preparing financial statements
                            in accordance with IFRS and GAAP; budgeting and forecasting;
                            conducting ratio analysis; horizontal and vertical analysis of financial
                            statements; reviewing and assessing internal controls; fixed assets
                            management; and continuous process improvement.
                        </p>
                    </div>
                </div>
            </div>
<!--            <div class="uk-padding uk-background-muted">
                <div class="uk-container uk-container-small">
                    <h3 class="uk-heading-bullet h2Style">Bruce Chambers</h3>
                    <div class="uk-panel">
                        <img class="uk-align-center uk-align-left@m uk-margin-remove-adjacent"  src="../assets/bruce.jpg" width="325" height="150" alt="Example image">
                        <p>
                            <br><br>
                            Bruce Chambers is a Senior Accountant at FINCOR, with an MBA in Finance, and more than 10 years of experience.

                        </p>
                        <p>
                            His specialties include: <br>
                            <span class="uk-text-small uk-margin-left" > - Financial Statement Preparation</span>
                            <br> <span class="uk-text-small uk-margin-left">- Budget Creation</span>
                            <br> <span class="uk-text-small uk-margin-left">- Strategic Planning</span> <br>
                        </p>

                        <p>
                            The consummate professional, Mr. Chambers has an excellent reputation for solving client problems,
                            improving customer satisfaction, and driving overall operational improvements.
                        </p>

                    </div>
                </div>
            </div>-->
        </div>
    </transition>
</template>

<script>
    export default {
        name: "managementTeam",
      metaInfo: {
        title: ' Management Team',
        meta: [{
          content: 'Meet the team at FINCOR that will be serving you. We are eager to help you in any financial situation you may have.'
        }]
      }
    }
</script>

<style scoped>
    .h2Style{
        font-family: 'Overlock SC';
    }
</style>